import { useMemo } from 'react';

import { EventTriggerType, Trigger } from '../../domain';
import { TriggerType } from './components/TriggerType';
import { TriggerValueDetailWithTooltip } from './components/TriggerValueDetailWithTooltip';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const GithubTriggerDetails = ({ trigger, triggerType }: Props) => {
  const eventName = useMemo(() => trigger.signature || '', [trigger.signature]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      <TriggerValueDetailWithTooltip
        label="Event Name"
        value={eventName}
        tooltip="This is the name parameter that should be used when sending events through the API or uploading a csv"
      />
    </div>
  );
};
